// Game constants and default values

export const DEFAULT_CUSTOM_COLORS = {
  whiteMigo: '#ecf0f1',
  blackMigo: '#2c3e50',
  yugoColor: '#e74c3c',
  whiteYugo: '#e74c3c',
  blackYugo: '#e74c3c',
  boardColor: '#d1e6f9',
  hoverColor: '#a8c3e8',
  lastMoveColor: 'rgba(46, 204, 113, 0.2)'
} as const;

export const DEFAULT_THEME = 'classic' as const;
export const DEFAULT_GAME_SOUNDS_ENABLED = true as const;
export const DEFAULT_NOTIFICATIONS_ENABLED = true as const;
export const DEFAULT_ILLEGAL_HOVER_ENABLED = true as const;

/** When false, global chat UI is hidden and cannot be opened (sidebar, players modal, panel). */
export const GLOBAL_CHAT_UI_ENABLED = false as const;

/** When false, Greedy is hidden in the sidebar and deep links (#greedy, ?greedy=1) do not open it. */
export const GREEDY_NAV_UI_ENABLED = false as const;

/** When false, Tournaments is hidden in the sidebar. */
export const TOURNAMENTS_NAV_UI_ENABLED = true as const;

/** PayPal hosted button for board purchases (customer-set price, CAD). */
export const PAYPAL_CLIENT_ID =
  process.env.REACT_APP_PAYPAL_CLIENT_ID ??
  'BAAYcMGiykT-RsOT5e-3H9QoHqzuJf_FEIbDjnhlXkGUKnME9xCOIkyWB-mZx93wcyn466l4xS2tJ8rkgs';

export const PAYPAL_HOSTED_BUTTON_ID =
  process.env.REACT_APP_PAYPAL_HOSTED_BUTTON_ID ?? 'GLWWEMMS9M3RA';

export const TIMER_OPTIONS = {
  MINUTES: [15, 10, 5, 3, 2, 1] as const,
  INCREMENTS: [5, 2, 1, 0] as const,
  DEFAULT_MINUTES: 10 as const,
  DEFAULT_INCREMENT: 0 as const
} as const;

export const GAME_MODES = {
  LOCAL: 'local',
  AI_1: 'ai-1',
  AI_2: 'ai-2',
  AI_CHALLENGER: 'ai-challenger',
  AI_SKILLED: 'ai-skilled',
  AI_3: 'ai-3',
  AI_ENGINE: 'ai-engine',
  ONLINE: 'online'
} as const;

export const PLAYER_COLORS = {
  WHITE: 'white',
  BLACK: 'black'
} as const;

export const GAME_STATUS = {
  WAITING: 'waiting',
  ACTIVE: 'active',
  FINISHED: 'finished'
} as const;

